import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs/Subscription';
import { OAuth2Service, OAuth2Status } from '../../angular-rest';

@Component({
	selector: 'app-password',
	templateUrl: './password.html',
	styleUrls: ['./../opzioni.css']
})

export class PasswordComponent {

	@Input() isLogin: boolean = false;

	@ViewChild('loading')
	loading: TemplateRef<any>;

	error = false;

	codice_fiscale: string;
	passwordOld: string;
	passwordNew: string;
	passwordNew2: string;
	show: boolean = false;
	changing: Subscription;
	formGroup = new FormGroup({
		codice_fiscale: new FormControl(),
		vecchia: new FormControl(),
		nuova: new FormControl(),
		nuova2: new FormControl()
	});

	constructor(
		public activeModal: NgbActiveModal,
		private modalService: NgbModal,
		private authService: OAuth2Service
	) { }

	checkOldPwd() {
		return this.passwordOld != null;
	}

	newPwdEqual() {
		return this.passwordNew == this.passwordNew2 && this.passwordNew != null && this.passwordNew2 != null && this.passwordOld != this.passwordNew;
	}

	check() {
		return this.checkOldPwd() && this.newPwdEqual();
	}

	confirm() {
		const modalRef = this.modalService.open(
			this.loading,
			{ backdrop: 'static' }
		);

		this.authService.reset_password({
			codice_fiscale: this.codice_fiscale,
			password_vecchia: this.passwordOld,
			password_nuova: this.passwordNew
		}).then(response => {
			modalRef.close();
			this.activeModal.close();
			location.reload()
		}).catch(err => {
			this.error = true;
			modalRef.close();
		})
	}
}


// WEBPACK FOOTER //
// ./src/app/opzioni/password/password.ts